import { useGetGroupedInvitations } from "../api/hooks";

export const useInvitationsBadgeCount = () => {
  const { data } = useGetGroupedInvitations();

  return {
    count: data.invitationCount,
  };
};
